<template>
    <div @click="emit" class="btn">
      <i class="fa" style="margin: 0 5px;" :class="iconClass" aria-hidden="true"></i>
      {{text}}
    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
            text:{
                type:String
            },
            iconClass:{
                  type:String
            }
        },
        computed:{
        },
        methods: {
          emit(){
              this.$emit("buttonBind");
          }
        },
        created(){

        },
        ready(){

        }
    }
</script>
<style scoped>
  .btn{
    border-radius: 4px;
    background: #f39800;
    color: #fff;
    display: inline-block;
    padding: 5px 15px;
    line-height: 1.5;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// iButton.vue?63c93442